import React, {useEffect} from 'react';
// import {connect} from 'react-redux';
import logo from '../assets/images/C_logo.png';
import phone from '../assets/images/contact_phone.png';
import mail from '../assets/images/contact_mail.png';
import address from '../assets/images/contact_location.png';
// import {onStartServiceCalls} from '../actions/onLogin';

const AboutUs = (props) => {

    // useEffect(() => {
    //     const token = localStorage.getItem('authToken');
    //     props.onStart(token)
    //     .then((res) => {
    //       console.log("the res is", res);

    //     })
    // }, [])

    const onContactusClicked = () => {
        props.history.push('/contact-us')
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 py-4 justify-content-between about">
            <div className="mb-4 about__description">
                <div className="optimized__d-flex-class flex-column align-items-center pt-2 mb-4">
                    <img className="img-fluid about__logo mb-1" alt="logo" src={logo}/>
                    <span className="home__logo-title about__logo-title">CARCLICK.<span className="home__logo-title--thin about__logo-title">IR</span></span>
                    <span className="home__logo-title--thin about__logo-title">مرکز تخصصی خرید و فروش</span>
                    <span className="home__logo-title about__logo-title">ماشین آلات سنگین</span>
                </div>
                <div className="about__main-content">
                    <p  className="about__content px-4 text-justify">
                        ما نیز همانند بسیاری از شما مراجعه کنندگان به این پایگاه مجازی، در برهه ای از زمان، سختی ها و پیچیدگی های مراحل خرید یا فروش را در شکل سنتی آن را چشیده ایم و به خوبی می دانیم که یافتن بهترین گزینه های ممکن برای خرید و یا سپردن برای فروش در بازار کنونی، کاری بس پر هزینه، زمان بر، و گیج کننده است.
                        از این رو به عنوان افرادی که نسبت به مقوله خودرو و تحولات گوناگون این صنعت پویا بی تفاوت نیستیم، بر آن شدیم که ضمن بررسی عمیق و علمی بازار خرید و فروش کنونی کشور، بررسی تجارب مشابه خارجی و درک نیاز ها، محدودیت ها، و فرصت های موجود، به ایجاد و راه اندازی پایگاهی مجازی بپردازیم.
                        کارکلیک با ساده سازی و روشن سازی فرآیند خرید و فروش انواع خودرو سنگین همچنین معرفی مشاغل مرتبط ، در راستای پایین آوردن هزینه در معاملات و تسریع در فروش شما را یاری می کند.
                        اگرچه نهایت سعی خود را نموده ایم تا به حداکثر سادگی در فرآیند انتخاب و ارائه خودرو دست پیدا کنیم، لیکن همواره مشتاق دریافت نظرات و پیشنهادات سازنده شما برای هرچه بهتر و کارآمدتر کردن این فرآیند هستیم. در صورتی که علاقمند به در میان گذاشتن نظرات خودباماهستید، آنها را به آدرس info@carclick.ir ارسال نمائید.
                    </p>
                </div>
                <hr className="about-separator mx-3"/>
                <div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={phone}></img>
                        <a className="about__contact-text px-2" href="tel:09391111792">۰۹۳۹۱۱۱۱۷۹۲</a>
                    </div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={address}></img>
                        <span className="about__contact-text text-right px-2">اقدسیه، نرسیده به میدان ارتش، نبش لنگری ساختمان رویال پلاک ۴ واحد ۱</span>
                    </div>
                    <div className="optimized__d-flex-class align-items-center mb-3 px-3">
                        <img className="img-fluid about__contact-img px-2" src={mail}></img>
                        <a className="about__contact-text px-2" href="mailto:info@carclick.ir">info@carclick.ir</a>
                    </div>
                </div>
            </div>

            <button className="about__btn py-4" onClick={onContactusClicked}>تماس با ما؟ <span>(کلیک کنید)</span></button>
        </div>
    );
}

// const mapDispatchToProps = (dispatch) => ({
//     onStart: (tok) => dispatch(onStartServiceCalls(tok))
// })

// export default connect(undefined, mapDispatchToProps)(AboutUs);
export default AboutUs;